import { useState } from "react"
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import ReplayIcon from "@mui/icons-material/Replay"

import { formatFullDateTime } from "../../../utils/format-date"
import { OrderRow, QueryResultStatus, queryResultMessage, queryResultStatusLabel } from "../Orders/orderTypes"
import { OrderDetailCard, OrderDetailField } from "./OrderDetailCard"

type OrderQueryCardProps = {
  order: OrderRow
}

const queryResultColor: Record<QueryResultStatus, "success" | "error" | "default"> = {
  success: "success",
  unavailable: "error",
  not_performed: "default",
}

export function OrderQueryCard({ order }: OrderQueryCardProps) {
  const [resultStatus, setResultStatus] = useState<QueryResultStatus>(order.queryResultStatus)
  const [isViewOpen, setViewOpen] = useState(false)

  return (
    <OrderDetailCard title="Dados da Consulta">
      <OrderDetailField label="Código da Consulta" value={order.queryCode} />
      <OrderDetailField label="Data e Horário" value={formatFullDateTime(order.date)} />
      <OrderDetailField label="Placa" value={<Box component="span" sx={{ letterSpacing: 1.5 }}>{order.plate}</Box>} />
      <OrderDetailField label="Tipo da Consulta" value={order.queryType} />
      <OrderDetailField
        label="Status"
        value={<Chip size="small" label={queryResultStatusLabel[resultStatus]} color={queryResultColor[resultStatus]} />}
      />
      <OrderDetailField label="Resultado" value={queryResultMessage[resultStatus]} />

      {resultStatus === "success" && (
        <Button variant="outlined" onClick={() => setViewOpen(true)}>
          Visualizar Consulta
        </Button>
      )}

      {resultStatus === "unavailable" && (
        <Button
          color="success"
          variant="contained"
          disableElevation
          startIcon={<ReplayIcon />}
          onClick={() => setResultStatus("success")}
        >
          Reconsultar
        </Button>
      )}

      <Dialog open={isViewOpen} onClose={() => setViewOpen(false)}>
        <DialogTitle>Consulta {order.queryCode}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <OrderDetailField label="Placa" value={<Box component="span" sx={{ letterSpacing: 1.5 }}>{order.plate}</Box>} />
          <OrderDetailField label="Tipo da Consulta" value={order.queryType} />
          <OrderDetailField label="Resultado" value={queryResultMessage[resultStatus]} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewOpen(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </OrderDetailCard>
  )
}
